import { render, staticRenderFns } from "./ComponentInputs.vue?vue&type=template&id=04f547ff&"
import script from "./ComponentInputs.vue?vue&type=script&lang=ts&"
export * from "./ComponentInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports